import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetAppMessageTemplatesRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetAppMessageTemplatesResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getAppMessageTemplatesApp = (request: GetAppMessageTemplatesRequest, options?: CashRequestOptions) =>
  post<GetAppMessageTemplatesRequest, GetAppMessageTemplatesResponse>(
    '/2.0/cash/get-app-message-templates-app',
    request,
    { ...options, rejectOnError: true }
  )
